import { useContext } from "react";

import { selectSelectedProductModel } from "../../../editor/messageDraftSelectors";
import { MessageDraftStoreContext } from "../../../editor/messageDraftStoreFactory";
import { TEXT_COMPOSER_DEFAULT_PRODUCT_MODEL } from "../mergeTagDefinitions";
import type { ProductGridModelValue } from "@/features/EmailEditor/plugins/productGridConstants";

/**
 * Model a freshly inserted product context starts on: the tile-derived model
 * (including discover — its per-grid binding is context-authorable).
 * Provider-optional so shared editor plugins (typeahead, merge-tag command)
 * stay usable outside the message-draft store; `dragonTileCategory` is frozen
 * per store, so a one-shot `getState()` read is enough.
 */
export function useDefaultProductContextModel(): ProductGridModelValue {
  const ctx = useContext(MessageDraftStoreContext);
  return ctx
    ? selectSelectedProductModel(ctx.store.getState())
    : TEXT_COMPOSER_DEFAULT_PRODUCT_MODEL;
}
